import getMuiTheme from 'material-ui/styles/getMuiTheme'

const syneronMuiTheme = client => {
  const muiTheme = getMuiTheme({
    userAgent: client, // (typeof navigator !== 'undefined' && navigator.userAgent) || 'all',
    palette: {
      primary1Color: '#ac208e',
      accent1Color: '#bbb',
    },
    tabs: {
      backgroundColor: '#fff',
      textColor: '#555',
      selectedTextColor: '#ac208e',
    },
    borderRadius: 0,
  })
  return muiTheme
}

export default syneronMuiTheme



// WEBPACK FOOTER //
// ./src/syneronMuiTheme.js